import React from 'react';
import { motion } from 'framer-motion';
import { StaticImage } from 'gatsby-plugin-image';
import { SocialLinks } from '../constants/constants';

interface FacebookFeedFallbackProps {
  message?: string;
  showImage?: boolean;
}

const FacebookFeedFallback: React.FC<FacebookFeedFallbackProps> = ({
  message = "We're having trouble loading our Facebook feed on mobile devices. Please visit our Facebook page directly to see our latest updates.",
  showImage = true,
}) => {
  return (
    <motion.div
      className="rounded-lg bg-white p-6 shadow-lg"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex flex-col items-center text-center">
        {showImage && (
          <div className="mb-4 flex justify-center">
            <StaticImage
              src="../images/icons/facebook.svg"
              alt="Facebook"
              className="h-16 w-16"
              placeholder="blurred"
            />
          </div>
        )}

        <h3 className="mb-4 text-xl font-semibold text-gray-800">
          Facebook Feed Unavailable
        </h3>

        <p className="mb-6 text-gray-600">{message}</p>

        <a
          href={SocialLinks.fb || 'https://www.facebook.com/'}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full bg-primary px-6 py-2 text-white transition-colors hover:bg-primary/80"
        >
          Visit Our Facebook Page
        </a>
      </div>
    </motion.div>
  );
};

export default FacebookFeedFallback;
